import react from "react";

const Divider = () => {
    return (
        <hr className=" w-3/4 border-7 mt-5 border-darkcyan mx-auto"></hr>
    )
};

export default Divider;
